"use client";
import React, { useEffect, useState } from "react";
import styles from "./index.module.scss";
import  {TestimonialText}  from "@/components/sections/TestimonialStudent";
import FilterComponent from "@/components/organisms/FilterComponent";

const TestimonialStudentSection = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rating, setRating] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);

  const limit = 6;

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleScrollZero = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', 
    });
  }

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const page = currentPage || 1;

        const res = await fetch(
          `https://adminapi.univoedtech.in/api/testimonials?page=${page}&limit=${limit}&type=text${rating ? `&rating=${rating}` : ""}`
        );
        const rawData = await res.json();
        const { data = {} } = rawData;
        const { testimonials = [], pagination = {} } = data;


        const allTestimonials = testimonials?.map((item) => item.testimonial) || [];

        setTestimonials(allTestimonials);
        setTotalPages(pagination.totalPages);
      } catch (error) {
        console.error("Error fetching testimonials:", error);
      } finally {
        setLoading(false);
      }

    };

    fetchTestimonials();
  }, [currentPage, rating]);

  useEffect(() => {
    if (!loading) {
      handleScrollZero();
    }
  }, [testimonials, loading]);

  return (
    <div className={styles.testimonialTextDiv}>
      {testimonials.length > 0 ? (
        <div className={styles.gridContainer}>
          {testimonials.map((item, index) => (
            <div key={index} className={styles.card}>
              <div className={styles.header}>
                <img
                  src={
                    item?.sent_by?.avatar ||
                    "https://static.amityonline.com/_s/avatar_nerd_man_vector_42477860_removebg_preview_68cec19df4_d0073b7893.webp"
                  }
                  alt={item?.sent_by?.name}
                  className={styles.avatar}
                  width={50}
                  height={50}
                />
                <div className={styles.nameDiv}>
                  <div className={styles.name}>{item?.sent_by?.name}</div>
                  {item?.sent_by?.title && (
                    <div className={styles.title}>{item?.sent_by?.title}</div>
                  )}
                </div>
              </div>
              <div className={styles.stars}>
                {Array.from({ length: 5 }).map((_, i) => (
                  <span key={i}>{i < item?.rating ? "★" : "☆"}</span>
                ))}
              </div>
              <TestimonialText {...item} />
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-8">
          {
            (loading && testimonials.length === 0) && (
              <p className="text-lg font-semibold text-gray-600">Loading...</p>
            )
          }

          {
            (!loading && testimonials.length === 0) && (
              <p className="text-lg font-semibold text-gray-600">No testimonials found.</p>
            )
          }
        </div>
      )}

      {testimonials.length !== 0 && <div className="flex items-center justify-center mt-6 gap-2 mx-4">

        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="px-3 py-1 rounded-md text-sm font-medium bg-gray-100 text-gray-700 hover:bg-gray-200 disabled:opacity-50"
        >
          &larr;
        </button>


        {Array.from({ length: totalPages }).map((_, i) => {
          const page = i + 1;
          const isActive = page === currentPage;
          const isNearCurrent =
            page === 1 ||
            page === totalPages ||
            Math.abs(page - currentPage) <= 1;

          if (!isNearCurrent) {
            if (
              (page === currentPage - 2 && page > 1) ||
              (page === currentPage + 2 && page < totalPages)
            ) {
              return (
                <span key={`dots-${i}`} className="px-2">
                  ...
                </span>
              );
            }
            return null;
          }

          return (
            <button
              key={i}
              onClick={() => handlePageChange(page)}
              className={`px-3 py-1 rounded-md text-sm font-medium ${
                isActive
                  ? "bg-white text-blue-900 font-bold"
                  : "bg-gray-100 text-gray-700"
              } hover:bg-gray-200`}
            >
              {page}
            </button>
          );
        })}

        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="px-3 py-1 rounded-md text-sm font-medium bg-gray-100 text-gray-700 hover:bg-gray-200 disabled:opacity-50"
        >
          &rarr;
        </button>
      </div>}
    </div>
  );
};

export default TestimonialStudentSection;
